import './common';
import 'components/share';
import 'components/up-button';
import Accordion from 'components/accordion';
import CallBack from 'components/callback';
import CameraView from 'components/camera-view';
import Contacts from 'components/contacts';
import Countdown from 'components/countdown';
import Favorite from 'components/favorite';
import FlexAccordion from 'components/accordion/flexAccordion';
import fullscreenTemplate from 'components/popup/krpano-popup.twig';
import Header from 'components/mobile-header/index';
import InputFile from 'components/forms/file';
import InputTelephone from 'components/forms/telephone';
import LazyLoad from 'vanilla-lazyload';
import Mapbox from 'components/mapbox';
import MapboxPopup from 'components/mapbox/mapbox-popup';
import Mediator from 'common/scripts/mediator';
import ObjectBanner from 'components/object-banner';
import Objects from 'components/objects';
import Parametric from 'components/parametric';
import Popup from 'components/popup';
import popupFullWhite from 'components/popup/full-white.twig';
import popupGalleryTemplate from 'components/popup/gallery-popup.twig';
import RangeSlider from 'components/range-slider';
import ScrollBy from 'components/scrollBy';
import Select from 'components/forms/select';
import Slider from 'components/slider';
import SliderDescription from 'components/slider-description';
import SliderHistory from 'components/slider-history';
import SliderPerson from 'components/slider-person';
import StartSection from 'components/start-section';
import Submit from 'components/forms/submit';
import SwiperFuct from 'components/swiper-fuct';
import TabBase from 'components/tabs/tabBase';
import Tabs from 'components/tabs/index';
import Tenders from 'components/tenders';
import ToggleHeight from 'components/toggleHeight';
import Tooltip from 'components/tooltip';
import Utils from 'common/scripts/utils';
import Validation from 'components/forms/validation';

const tabletPortrait = 670;
const tabletLandscape = 960;
const header = new Header();
const mediator = new Mediator();
const mapContainers = document.querySelectorAll('.j-mapbox');
const mapContainersInPopup = document.querySelectorAll('.j-mapbox-in-popup');
const mapPopup = document.querySelector('.j-mapbox-popup');
const openLinks = document.querySelectorAll('.j-mapbox-popup-open');
const tabsAll = document.querySelectorAll('.j-tabs');
// т.к. фиксированный хедер нужен не на всех страницах, определяем позицианирование через наличие элемента
const autoFixedElement = document.querySelector('.j-autofixed-header');
const autoFixedElementMobile = document.querySelector('.j-autofixed-header-mob');
let tabsMap = document.querySelector('.j-tabs-map');
let tabsProjects = document.querySelector('.j-tabs-projects');

header.init({
    element                : '.j-header',
    autoFixed              : autoFixedElement,
    autoFixedMobOnly       : autoFixedElementMobile,
    autoPositionCloseButton: true,
    returnPosition         : true
});

// Первый экран (анимация)
if (document.querySelector('.j-start-section')) {
    new StartSection().init();
}

// Cкролл по якорям
const anchors = Array.from(document.querySelectorAll('.j-anchor'));
const headerWrap = document.querySelector('.j-header');

if (anchors.length) {
    const scrollBy = new ScrollBy();

    scrollBy.init({
        takeElements: [headerWrap],
        anchors
    });
}


/**
 * Попап инлайновый
 */
const callBackPopups = Array.from(document.querySelectorAll('.j-open-callback-popup'));

if (callBackPopups.length) {
    callBackPopups.forEach((item) => {
        const popup = new Popup();

        popup.init({
            target  : item,
            template: popupFullWhite
        });
    });
}

const basePopups = Array.from(document.querySelectorAll('.j-open-base-popup'));

if (basePopups.length) {
    basePopups.forEach((item) => {
        const popup = new Popup();

        popup.init({
            target  : item,
            template: popupFullWhite
        });
    });

    mediator.subscribe('openPopup', (popup) => {
        const slidersDescription = Array.from(popup.popup.querySelectorAll('.j-slider-description'));

        if (slidersDescription.length) {
            slidersDescription.forEach((container) => {
                new SliderDescription({container}).init();
            });
        }
    });
}

const certificatesPopups = Array.from(document.querySelectorAll('.j-open-certificates-popup'));

if (certificatesPopups.length) {
    certificatesPopups.forEach((item) => {
        const popup = new Popup();

        popup.init({
            target  : item,
            template: popupFullWhite
        });
    });
}

const galleryPopups = Array.from(document.querySelectorAll('.j-gallery-popup'));

if (galleryPopups.length) {
    galleryPopups.forEach((item) => {
        const popup = new Popup();

        popup.init({
            target   : item,
            template : popupGalleryTemplate,
            isGallery: true
        });
    });
}

const panoPopups = Array.from(document.querySelectorAll('.j-krpano-popup'));

if (panoPopups.length) {
    panoPopups.forEach((item) => {
        const popup = new Popup();

        popup.init({
            target  : item,
            template: fullscreenTemplate
        });
    });
}

/**
 * инициализация табов
 */
if (tabsMap) {
    tabsMap = new Tabs();
    tabsMap.init({element: '.j-tabs-map'});
}

if (tabsProjects) {
    tabsProjects = new Tabs();
    tabsProjects.init({element: '.j-tabs-projects'});
}

if (tabsAll.length) {
    tabsAll.forEach(() => {
        const tabs = new Tabs();

        tabs.init({element: '.j-tabs'});
    });
}

const tabsBase = Array.from(document.querySelectorAll('.j-base-tab'));

if (tabsBase.length) {
    new TabBase().init();
}

const tabsProjectsCollapsed = document.querySelector('.j-tabs-projects');

if (window.screen.availWidth < tabletLandscape && tabsProjectsCollapsed) {
    let opened = false;

    tabsProjectsCollapsed.addEventListener('click', () => {
        if (opened) {
            tabsProjects.tabsParent.classList.remove('is-opened');
            tabsProjects.tabs.forEach((link) => {
                link.style.pointerEvents = 'none';
            });
            opened = false;
        } else {
            tabsProjects.tabsParent.classList.add('is-opened');
            tabsProjects.tabs.forEach((link) => {
                link.style.pointerEvents = 'auto';
                link.style.width = '100%';
            });
        }
    });

    tabsProjects.tabs.forEach((link) => {
        link.addEventListener('click', (event) => {
            link.style.width = '0';
            event.target.style.width = 'max-content';
            opened = true;
        });
    });
}

/**
 * слайдеры с одним видимым слайдом
 */
const oneSliders = document.querySelectorAll('.j-oneslide-slider');

if (oneSliders) {
    oneSliders.forEach((slide) => {
        const oneSlider = new Slider();

        oneSlider.init({
            target: slide,
            dots  : true
        });
    });
}

const autoSliders = document.querySelectorAll('.j-autoplay-slider');

if (autoSliders) {
    autoSliders.forEach((slide) => {
        const autoSlider = new Slider();

        autoSlider.init({
            target     : slide,
            dots       : true,
            sliderArrow: true
        });
    });
}

const teaserSliders = document.querySelectorAll('.j-carousel-teaser');

if (teaserSliders.length) {
    teaserSliders.forEach((item) => {
        const slider = new Slider();

        slider.init({target: item});
    });
}

const verticalSliders = document.querySelectorAll('.j-vertical-carousel');

if (verticalSliders.length) {
    verticalSliders.forEach((item) => {
        const slider = new Slider();

        slider.init({
            target       : item,
            vertical     : true,
            separateArrow: true
        });
    });
}

/**
 * подгрузка объектов на главной
 */
const objectsBtn = document.querySelector('.j-show-objects');

if (objectsBtn) {
    // eslint-disable-next-line no-new
    new Objects(objectsBtn);
}

const contactsWrappers = document.querySelectorAll('.j-contacts');

if (contactsWrappers.length) {
    contactsWrappers.forEach((wrapper) => {
        const contactList = new Contacts({wrapper});

        contactList.init();
    });
}

/**
 * инициализация карты
 */
if (mapContainers.length) {
    mapContainers.forEach((mapContainer) => {
        const map = new Mapbox();

        map.init(mapContainer);
    });
}
if (mapContainersInPopup.length) {
    mapContainersInPopup.forEach((mapContainer) => {
        const map = new MapboxPopup();

        map.init(mapContainer);
        if (mapPopup && openLinks.length) {
            map.initPopup(mapPopup, openLinks);
        }
    });
}

/**
 * Валидация инпутов
 */

const inputs = Array.from(document.querySelectorAll('.j-input'));

if (inputs.length) {
    inputs.forEach((item) => {
        const inputValidation = new Validation();
        const errorMessage = item.dataset.error;

        inputValidation.init({
            target: item,
            error : errorMessage
        });
    });
}

/**
 * Маска для инпута с телефоном
 */
const inputTel = new InputTelephone();
const phoneInputs = Array.from(document.querySelectorAll('input[type="tel"]'));

if (phoneInputs.length) {
    inputTel.init({input: phoneInputs});
}

mediator.subscribe('openPopup', () => {
    const inputTelInPopup = new InputTelephone();
    const phoneInputsInPopup = Array.from(document.querySelectorAll('input[type="tel"]'));

    if (phoneInputsInPopup.length) {
        inputTelInPopup.init({input: phoneInputsInPopup});
    }

    const inputsInPopup = Array.from(document.querySelectorAll('.j-input'));

    if (inputsInPopup.length) {
        inputsInPopup.forEach((item) => {
            const inputValidationInPopup = new Validation();
            const errorInPopup = item.dataset.error;

            inputValidationInPopup.init({
                target: item,
                error : errorInPopup
            });
        });
    }

    const submitSelectorInPopup = Array.from(document.querySelectorAll('.j-input-submit'));

    if (submitSelectorInPopup.length) {
        submitSelectorInPopup.forEach((item) => {
            const submitInputsInPopup = new Submit();

            submitInputsInPopup.init({target: item});
        });
    }
});

/**
 * Обработчик отправки формы и валидация при сабмите
 */
const submitSelector = Array.from(document.querySelectorAll('.j-input-submit'));

if (submitSelector.length) {
    submitSelector.forEach((item) => {
        const submitInputs = new Submit();

        submitInputs.init({target: item});
    });
}

// Поведение списков в футере
if (window.screen.availWidth < tabletPortrait) {
    const footerLists = Array.from(document.querySelectorAll('.b-footer-offer'));
    const toggleListClass = (list) => {
        if (list.classList.contains('is-open')) {
            list.classList.remove('is-open');

            return;
        }

        footerLists.forEach((item) => {
            item.classList.remove('is-open');
        });
        list.classList.add('is-open');
    };

    footerLists.forEach((list) => {
        list.addEventListener('click', () => {
            toggleListClass(list);
        });
    });
}

if (document.querySelector('.j-parametric')) {
    new Parametric().init();
}

if (document.querySelector('.j-tooltip')) {
    new Tooltip().init();
}

const flatTabs = document.querySelectorAll('.j-flat-card__tabs');

/**
 * инициализация табов
 */
if (flatTabs.length) {
    tabsMap = new Tabs();
    tabsMap.init({element: '.j-flat-card__tabs'});
}


const flatRangeSlider = document.querySelectorAll('.j-flat__range-slider');

if (flatRangeSlider.length) {
    flatRangeSlider.forEach((slider) => {
        new RangeSlider().init({wrapper: slider});
    });
}

const faveParents = document.querySelectorAll('.j-flat__favorite');

if (faveParents.length) {
    new Favorite().init({elem: document});
}

const mortgageMultiSelect = document.querySelector('.j-flat-mortgage__select');

if (mortgageMultiSelect) {
    new Select({
        element      : '.j-flat-mortgage__select',
        disableSearch: true
    }).init();
}

const progressCarousel = document.querySelector('.j-progress-carousel');

if (progressCarousel) {
    const progressSelect = progressCarousel.querySelector('.j-progress-select');
    const swiperFuctSimple = progressCarousel.querySelector('.j-swiper-fuct-simple');

    if (progressSelect && swiperFuctSimple) {
        const swiper = new SwiperFuct({container: swiperFuctSimple});

        swiper.init();

        new Select({
            element      : '.j-progress-select',
            disableSearch: true,
            afterChange  : (val) => {
                swiper.filterSlides(val, 'data-year');
            }
        }).init();
    }
}


/**
 * инициализация аккордиона
 */
const accordions = document.querySelectorAll('.j-accordion');

if (accordions.length) {
    accordions.forEach((item) => {
        const accordion = new Accordion();

        accordion.init({target: item});
    });
}

const flexAccordions = document.querySelectorAll('.j-flex-accordion');

if (flexAccordions.length) {
    flexAccordions.forEach((item) => {
        const accordion = new FlexAccordion();

        accordion.init({target: item});
    });
}

/**
 * инициализация трансляций и видов из окон
 */
const cameras = document.querySelectorAll('.j-camera-view');

if (cameras.length) {
    cameras.forEach((camera) => {
        const cameraView = new CameraView();

        cameraView.init({target: camera});
    });
}

/**
 * скрытие пуш-баннера
 */
const pushes = document.querySelector('.j-push-banner');

if (pushes) {
    const pushesName = 'pushBanner';

    if (sessionStorage.getItem(pushesName)) {
        pushes.remove();
    } else {
        const pushesCloseBtn = pushes.querySelector('button');

        pushes.classList.add('is-show');
        pushesCloseBtn.addEventListener('click', () => {
            pushes.remove();
            sessionStorage.setItem(pushesName, true);
        });
    }
}

/**
 * инициализация обратного счетчика
 */
const countdown = document.querySelector('.j-countdown');

if (countdown) {
    const currentPath = window.location.pathname;
    const isCurrentFlatPage = currentPath.indexOf('/flat') !== -1;
    const name = countdown.dataset.name;

    if (!sessionStorage.getItem(name)) {
        const count = new Countdown();

        count.init({
            parent      : countdown,
            sessionName : name,
            isMobileHide: isCurrentFlatPage
        });
    }
}

// eslint-disable-next-line func-style
function initInputsFile(container = null) {
    const inputsFile = Array.from((container || document).querySelectorAll('.j-input-file'));

    if (inputsFile.length) {
        inputsFile.forEach((target) => {
            new InputFile({container: target}).init();
        });
    }
}

initInputsFile();

mediator.subscribe('openPopup', (popup) => {
    if (popup.content && popup.content.querySelector('form')) {
        new CallBack({
            container: popup.content,
            target   : popup.target
        }).init(); // eslint-disable-line
    }

    initInputsFile(popup.content);
});


const toggles = Array.from(document.querySelectorAll('.j-toggle-content'));

if (toggles.length) {
    toggles.forEach((element) => {
        new ToggleHeight({element}).init();
    });
}

const slidersPerson = Array.from(document.querySelectorAll('.j-slider-person'));

if (slidersPerson.length) {
    slidersPerson.forEach((container) => {
        new SliderPerson({container}).init();
    });
}

const slidersDescription = Array.from(document.querySelectorAll('.j-slider-description'));

if (slidersDescription.length) {
    slidersDescription.forEach((container) => {
        new SliderDescription({container}).init();
    });
}

const swiperFuct = Array.from(document.querySelectorAll('.j-swiper-fuct'));

if (swiperFuct.length) {
    swiperFuct.forEach((container) => {
        const swiper = new SwiperFuct({container});

        swiper.init();
        swiper.initArrows();
    });
}

const slidersHistory = Array.from(document.querySelectorAll('.j-slider-history'));

if (slidersHistory.length) {
    slidersHistory.forEach((container) => {
        new SliderHistory({container}).init();
    });
}

const textToggleBtns = Array.from(document.querySelectorAll('.j-toggle-button'));

if (textToggleBtns.length) {
    textToggleBtns.forEach((button) => {
        button.addEventListener('click', () => {
            const text = button.parentNode.querySelector('.j-toggle-text');

            if (button.classList.contains('is-open')) {
                button.classList.remove('is-open');
                text.style.maxHeight = '0';
            } else {
                button.classList.add('is-open');
                text.style.maxHeight = `${text.scrollHeight}px`;
            }
        });
    });
}

const objectBannerSelector = Array.from(document.querySelectorAll('.j-object-banner'));

if (objectBannerSelector.length) {
    objectBannerSelector.forEach((objectBannerElem) => {
        const objectBanner = new ObjectBanner();

        objectBanner.init(objectBannerElem);
    });
}

const lazyLoadElements = Array.from(document.querySelectorAll('.j-lazy'));

if (lazyLoadElements.length) {
    const lazyLoadInstance = new LazyLoad({
        // eslint-disable-next-line camelcase
        elements_selector: '.j-lazy',
        threshold        : 0,
        // eslint-disable-next-line camelcase
        callback_loading : (el) => {
            el.parentElement.classList.add('loading');
        },
        // eslint-disable-next-line camelcase
        callback_loaded: (el) => {
            el.parentElement.classList.add('loaded');
        }
    });

    mediator.subscribe('sliderReady', () => {
        lazyLoadInstance.update();
    });
}

const staticGalleryPopups = Array.from(document.querySelectorAll('.j-static-gallery-popup'));

if (staticGalleryPopups.length) {
    staticGalleryPopups.forEach((item) => {
        const popup = new Popup();

        popup.init({
            target  : item,
            template: popupFullWhite
        });
    });
}

const subMenus = Array.from(document.querySelectorAll('.j-submenu'));

if (subMenus.length) {
    document.addEventListener('click', (event) => {
        const target = event.target;
        const parentTarget = target.parentNode;

        if (target.classList.contains('j-submenu')) {
            target.classList.toggle('is-active');
        } else if (parentTarget.classList.contains('j-submenu')) {
            parentTarget.classList.toggle('is-active');
        }
    });
}

const objectContact = document.querySelector('.j-object-contact');

if (objectContact) {
    const objectContactShowmap = objectContact.querySelector('.j-object-contacts-showmap');
    const mapWrapper = objectContact.querySelector('.j-mapbox');
    const closeMap = objectContact.querySelector('.j-close-map');
    const activeClass = 'is-active';

    objectContactShowmap.addEventListener('click', () => {
        mapWrapper.classList.add(activeClass);
    });
    closeMap.addEventListener('click', () => {
        mapWrapper.classList.remove(activeClass);
    });
}

const tendersWrapper = Array.from(document.querySelectorAll('.j-tenders'));

if (tendersWrapper.length) {
    tendersWrapper.forEach((wrapper) => {
        const tender = new Tenders();

        tender.init({target: wrapper});
    });
}

const subheader = document.querySelector('.j-subheader');

if (subheader) {
    const wrapper = document.querySelector('.j-subheader__wrapper');
    const headerWrapper = document.querySelector('.b-header-wrap');
    const modifyClass = 'is-top';

    if (wrapper) {
        document.addEventListener('scroll', () => {
            if (Utils.isInViewport(wrapper, 85)) {
                subheader.classList.remove(modifyClass);

                return;
            }

            if (headerWrapper.classList.contains('b-header_position_hide')) {
                subheader.classList.remove(modifyClass);
            } else {
                subheader.classList.add(modifyClass);
            }
        });
    }
}
